import { Button, Form, Input, Modal } from 'antd'
import React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { transactionLaneDataHandle } from '../../Rtd/state/actions'

const EditNameModal = ({ nestedModalOpen, setNestedModalOpen, form, userAuthKey }) => {

    const dispatch = useDispatch()

    const handleCancel = () => {
        setNestedModalOpen({ ...nestedModalOpen, isEditNameModalOpen: false, editDocDetails: {} })
    }

    const handleEditNameSave = (values) => {
        
        let urlData = {
            updatedName: values?.editedName,
            ...(nestedModalOpen?.editDocDetails?.isResureSignDoc
              ? {
                  offerDoc: false,
                  isResureSignDoc: true,
                }
              : nestedModalOpen?.editDocDetails?.contractId
              ? {
                  offerDoc: true,
                }
              : {
                  offerDoc: false,
                }),
          };

        dispatch(transactionLaneDataHandle.changeDocName({ urlData, documentId: nestedModalOpen?.editDocDetails?._id, userAuthKey }))

        handleCancel()
    }

    useEffect(() => {
        form?.setFieldsValue({ editedName: nestedModalOpen?.editDocDetails?.updatedName || nestedModalOpen?.editDocDetails?.documentName || nestedModalOpen?.editDocDetails?.fileName })
    }, [nestedModalOpen?.editDocDetails])

    return (
        <>
            <Modal visible={nestedModalOpen?.isEditNameModalOpen} onCancel={handleCancel} title={<span className='commonModalTitle'>Edit Name</span>} footer={false}>
                <Form
                    form={form}
                    initialValues={{
                        editedName: nestedModalOpen?.editDocDetails?.updatedName || nestedModalOpen?.editDocDetails?.documentName || nestedModalOpen?.editDocDetails?.fileName
                    }}
                    onFinish={handleEditNameSave}
                >
                    <Form.Item label="Name" name="editedName">
                        <Input>
                        </Input>
                    </Form.Item>
                    <Form.Item>
                        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                            <Button type='primary' htmlType='submit'>Save</Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default EditNameModal